import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import { RECOMMEND_SEARCH_WORD_COPY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { reDirectPage, setDetailPageUrl } from '../../../../../lib/common';
import './RecommendSearchWordDetailNavbar.scss';

const RecommendSearchWordDetailNavbar = (props) => {
  const { recommendSearchWordId } = props;

  return (
    <FixedBottomNavBar className="recommend-search-word-detail-navbar">
      <div className="button-group">
        <Button
          color="primary"
          text="복사하기"
          onClick={() =>
            reDirectPage({ path: setDetailPageUrl(RECOMMEND_SEARCH_WORD_COPY_URL_PATH, recommendSearchWordId) })
          }
        />
      </div>
    </FixedBottomNavBar>
  );
};

export default RecommendSearchWordDetailNavbar;
